<template>
  <div class="box">
    <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    <van-popup v-model="show" closeable>
      <div class="help">长按下方图片转发给好友</div>
      <img :src="img"  style="width: 80vw; display: block;">
    </van-popup>
    <img class="title" src="../assets/images/share/title.png" alt="">
    <div class="sm">
      <img class="hd_title" src="../assets/images/share/hdgz_title.png" alt="">
      1. 活动时间：2021年8月20日—2021年9月10日（在活动时间内，调查数据采集满则活动自动结束）；<br>
      2. 参与方式：在此页面点击下方“我同意以上规则，立即参与推广”按钮。<br>
      3. 活动规则：用户在活动期间参与活动，每月最多发放600元红包奖励，超出部分次月发放。<br>
      （1）好友必须是水稻种植户。<br>
      （2）好友通过您分享的二维码进行参与调查，通过审核后，对方将获得10元奖励（如果当地调查数据已满，则为2元奖励），对方是新用户您将获得5元奖励，对方是老用户您将获得2元奖励。<br>
      （3）活动期间，如发现有用户通过不正当手段（包括但不限于侵犯第三人合法权益、虚假数据、作弊、扰乱系统、实施网络攻击、恶意套现、批量注册等）参加活动而有碍其他用户公平参加本次活动或有违反活动目的之行为，活动举办方有权取消该用户获奖资格或取消、追回该用户通过参加活动所获赠品或权益。如该作弊行为给活动举办方造成损失的，活动举办方保留向该用户追究赔偿的权利。<br>
    </div>
    <div class="btn">
      <van-button @click="showPopup" plain round block type="warning">我同意以上规则，立即参与推广</van-button>
    </div>
  </div>
</template>

<script>
import store from '../store/index'
export default {
  data() {
    return {
      painting: null,
      img:'',
      show: false
    }
  },
  created() {
    const userInfo = store.getters.userInfo
    this.painting = {
      width:`750px`,
      height:`1000px`,
      // background: '#f4f5f7',
      views: [
        {
          type: 'image',
          url: require('../assets/images/share/fx_bg.png'),
          css: {
            width:`750px`,
            height:`1000px`,
            top: '0'
          }
        },
        {
          type: 'image',
          url: require('../assets/images/share/kh.png'),
          css:{
            width:`516px`,
            height:`136px`,
            top:`114px`,
            left: `117px`,
          }
        },
        {
          type: 'image',
          url: require('../assets/images/share/hb.png'),
          css:{
            width:`516px`,
            height:`562px`,
            top:`290px`,
            left: `117px`,
          }
        },
        {
          type: 'qrcode',
          content: `${process.env.VUE_APP_BASE_URL}/sudiao/#/question/detail?qid=7&t_id=${userInfo.user.id}`,
          css: {
            top: `320px`,
            left: `194px`,
            color: '#333',
            width: `360px`,
            height: `360px`
          }
        },
        {
          type: 'text',
          text: '- 长按“识别图中二维码”参与 -',
          css: [
            {
              top:`870px`,
              left: `80px`,
              color:'rgba(52,52,52,1)',
              fontSize: '42px'
            }
          ]
        },
      ],
    }
  },
  methods:{
    success(src) {
      this.img=src
    },
    fail(err) {
      console.log('fail', err)
    },
    showPopup() {
      this.show = true
    }
  }
}
</script>

<style scoped>
.box {
  background: url(../assets/images/share/hdgz_bg.png) repeat;
  background-size: 1.03125rem 0.71875rem;
  overflow: auto;
  height: 100vh;
}
.help {
  font-size: 36px;
  color: #333;
  text-align: center;
  margin: 30px 0;
}
.sm {
  font-size: 28px;
  color: white;
  padding: 0 0.5rem 0.5rem;
  margin-bottom: 100px;
}

.title {
  width: 600px;
  /* height: 0.53125rem; */
  margin: 0.5rem auto;
  display: block;
}

.hd_title {
  width: 2.125rem;
  height: 0.53125rem;
  margin: 0.5rem auto;
  display: block;
}

.btn {
  position: fixed;
  bottom: 0;
  left: 80px;
  padding: 0.5rem 0;
  width: 600px;
}
</style>